// CSS Modules - component class name prefix: ListTeaser__

<template>
  <div :class="[{ ListTeaser__linked: result.link }, $style.container]">
    <a
      v-if="result.link && !result.isVideo"
      :class="$style.teaserLink"
      :href="result.link"
      :target="result.target ? result.target : '_self'"
    ></a>
    <div
      v-if="result.image"
      :class="[$style.mediaLink, { ListTeaser__videoLink: result.isVideo }]"
    >
      <i v-if="result.isVideo" class="fab fa-youtube"></i>
      <img :src="result.image" :alt="result.text" />
    </div>
    <div :class="$style.caption">
      <div :class="$style.headingRow">
        <div v-if="result.subHeading" :class="$style.subHeading">
          {{ result.subHeading }}
        </div>
        <img
          v-if="result.flag"
          :class="$style.flag"
          :src="result.flag"
          alt=""
        />
      </div>
      <div v-if="result.country_name" :class="$style.subHeading">
        {{ result.country_name }}
      </div>
      <h5 v-if="result.title" :class="$style.title">{{ result.title }}</h5>
      <div
        v-if="
          result.company &&
            !result.phone &&
            !result.fax &&
            !result.website &&
            !result.email
        "
        :class="$style.text"
      >
        {{ result.company }}
      </div>
      <h5
        v-if="
          result.company &&
            (result.phone || result.fax || result.website || result.email)
        "
        :class="$style.title"
      >
        {{ result.company }}
      </h5>
      <div v-if="result.address" :class="$style.address">
        {{ result.address }}<br />
        {{ result.country }}
      </div>
      <div v-if="result.text" :class="$style.text">{{ result.text }}</div>
      <div
        v-if="result.phone || result.fax || result.website || result.email"
        :class="$style.linkBlock"
      >
        <a v-if="result.phone" :href="`tel:${result.phone}`">
          <i class="fas fa-phone-alt"></i>
          {{ result.phone }}
        </a>
        <a v-if="result.fax">
          <i class="fas fa-fax"></i>
          {{ result.fax }}
        </a>
        <a v-if="result.email" :href="`mailto:${result.email}`">
          <i class="fas fa-envelope"></i>
          {{ result.email }}
        </a>
        <a v-if="result.website" :href="result.website" target="_blank">
          <i class="fas fa-globe-americas"></i>
          {{ result.website }}
        </a>
      </div>
      <div v-if="result.files" :class="$style.downloads">
        <a
          :key="index"
          v-for="(file, index) in result.files"
          :href="file.url"
          target="_blank"
        >
          <i v-if="file.name === 'PDF'" class="fas fa-file-pdf"></i>
          <i
            v-if="file.name === 'DOC' || file.name === 'DOCX'"
            class="fas fa-file-word"
          ></i>
          <i v-if="file.name === 'JPG'" class="fas fa-file-image"></i>
          {{ file.name }}
        </a>
      </div>
    </div>
    <a
      v-if="result.link && result.isVideo"
      :class="$style.teaserLink"
      @click="isModalOpen = true"
    >
    </a>
    <Modal
      v-if="result.isVideo"
      :isModalOpen="isModalOpen"
      :isVideo="result.isVideo"
      @closeModal="isModalOpen = false"
    >
      <iframe
        :src="result.link"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </Modal>
  </div>
</template>

<script>
import Modal from "../Modal/Modal";

export default {
  name: "ListTeaser",
  components: {
    Modal
  },
  props: {
    result: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isModalOpen: false
    };
  }
};
</script>

<style module lang="scss">
@import "./ListTeaser.scss";
</style>
